// ================ Action types ================ //

import { SharetribeApi } from '../util/api';
import { StatusCode } from '../util/enums';
import { storableError } from '../util/errors';

const ActionTypes = {
  UPDATE_LISTING_COUNTRY_REQUEST: 'app/global/UPDATE_LISTING_COUNTRY_REQUEST',
  UPDATE_LISTING_COUNTRY_SUCCESS: 'app/global/UPDATE_LISTING_COUNTRY_SUCCESS',
  UPDATE_LISTING_COUNTRY_ERROR: 'app/global/UPDATE_LISTING_COUNTRY_ERROR',
};

// ================ Initial State ================ //
const initialState = {
  updateListingCountryInProgress: false,
  updateListingCountryError: null,
};

// ================ Reducers ================ //
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.UPDATE_LISTING_COUNTRY_REQUEST:
      return { ...state, updateListingCountryInProgress: true, updateListingCountryError: null };
    case ActionTypes.UPDATE_LISTING_COUNTRY_SUCCESS:
      return { ...state, updateListingCountryInProgress: false };
    case ActionTypes.UPDATE_LISTING_COUNTRY_ERROR:
      return {
        ...state,
        updateListingCountryInProgress: false,
        updateListingCountryError: payload,
      };
    default:
      return state;
  }
}
// ================ Action Creators ================ //
export const updateListingCountryRequest = () => ({
  type: ActionTypes.UPDATE_LISTING_COUNTRY_REQUEST,
});
export const updateListingCountrySuccess = () => ({
  type: ActionTypes.UPDATE_LISTING_COUNTRY_SUCCESS,
});
export const updateListingCountryError = error => ({
  type: ActionTypes.UPDATE_LISTING_COUNTRY_ERROR,
  payload: error,
});

// ================ Thunks ================ //
export const updateCountryInListing = params => async (dispatch, getState, sdk) => {
  dispatch(updateListingCountryRequest());
  try {
    const response = await SharetribeApi.updateCountryInListing(params);
    if (response.statusCode === StatusCode.SUCCESS) {
      dispatch(updateListingCountrySuccess());
      return response;
    } else {
      const error = storableError(
        response.error || 'Failed to update country in listing due to unknown error'
      );
      dispatch(updateListingCountryError(error));
      return null;
    }
  } catch (error) {
    const e = storableError(error);
    dispatch(updateListingCountryError(e));
  }
};
